import { url_servicios } from 'src/app/config/config';

export const AUTH_CONSTS = {
  token: 'token',
  refreshToken: 'refresh_token',
  user: 'user',
  auth: 'authenticated',
  sessionDeadlineAt: 'session_deadline_at',
  twoFactorRequired: 'two_factor_required',
  twoFactorExpiresAt: 'expires_at',
  twoFactorDevelopmentMode: 'two_factor_development_mode',
  twoFactorSmsServiceActive: 'two_factor_sms_service_active',
  twoFactorAttemptsRemaining: 'two_factor_attempts_remaining',
  twoFactorAvailableMethods: 'two_factor_available_methods',
  twoFactorUserRole: 'two_factor_user_role',
  tempAuthToken: 'temp_auth_token',
  pendingLocationSelection: 'pending_location_selection',
  pendingLocations: 'pending_locations',
  pendingUser: 'pending_user',
};

export const AUTH_URLS = {
  login: `${url_servicios}/login`,
  loginParent: `${url_servicios}/login-parent`,
  logout: `${url_servicios}/logout`,
  me: `${url_servicios}/me`,
  refresh: `${url_servicios}/refresh`,
  twoFactorVerify: `${url_servicios}/two-factor/verify`,
  twoFactorResend: `${url_servicios}/two-factor/resend`,
  twoFactorSendCode: `${url_servicios}/two-factor/send-code`,
  twoFactorBackupCode: `${url_servicios}/two-factor/backup-code`,
  twoFactorStatus: `${url_servicios}/two-factor/status`,
  // Password Reset URLs
  passwordResetRequest: `${url_servicios}/password-reset/request`,
  passwordResetVerify: `${url_servicios}/password-reset/verify`,
  passwordResetChange: `${url_servicios}/password-reset/change`,
  // Location Selection URLs
  selectLocation: `${url_servicios}/auth/select-location`,
  changeLocation: `${url_servicios}/auth/change-location`,
  userLocations: `${url_servicios}/auth/user-locations`,
};
